import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router'
import { format, getDate, set } from 'date-fns'
import './../../assets/profile.css'

const Profile = () => {

    const {user: currentUser} = useSelector((state) => state.auth)

    if(!currentUser){
        return <Navigate  to={'/'}/>
    }

  return (
    <div className="container height-100 d-flex justify-content-center align-items-center">
      <div className="card text-center">
        <div className="py-4 p-2">
          <h2 class="card-title">Perfil</h2>
          <div className="mt-3 d-flex flex-row justify-content-center">
            <h6>{currentUser.name}</h6>
            <span className="dots">
              <i className="fa fa-check" />
            </span>
          </div>
          <span>{currentUser.userName}</span>
          <div className="mt-3">
            <button className="btn btn-secondary">Follow</button>
            <button className="btn btn-outline-secondary">
              <i className="fa fa-users" /> 451
            </button>
          </div>
        </div>
        <div style={{display: 'flex'}}>
          <p className='card-text'>
            {`Numero de telefono: ${currentUser.phoneNumber}`}
          </p>
          <ul className="list-unstyled list">
            <li>
              <span className="font-weight-bold">Solicitudes creadas</span>
              <div>
                <span className="mr-1">5</span>
                <i className="fa fa-angle-right" />
              </div>
            </li>
            <li>
              <span className="font-weight-bold">Solicitudes aprobadas</span>
              <div>
                <span className="mr-1">45</span>
                <i className="fa fa-angle-right" />
              </div>
            </li>
            <li>
              <span className="font-weight-bold">Solicitudes pendientes</span>
              <div>
                <span className="mr-1">15</span>
                <i className="fa fa-angle-right" />
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Profile;
